import type { OrderDetailsExtended } from 'app/src/model'
import { creditCollection } from 'app/src/msw/shopping/initialSeed/credit'
import type { CreditGetResult } from 'app/src/services/welfareportal/shopping-api'

const getUpdatedCredits = (credit: CreditGetResult, order: OrderDetailsExtended, isCancel?: boolean) => {
  const welfareCategoryArt100Credit = { ...credit.creditByServiceCategory['welfareArt100'] }
  const welfareCategoryArt51Credit = { ...credit.creditByServiceCategory['welfareArt51'] }
  let welfareCategoryArt100CreditAvailable = 0
  let welfareCategoryArt51CreditAvailable = 0
  if (welfareCategoryArt100Credit) {
    welfareCategoryArt100CreditAvailable = isCancel
      ? (welfareCategoryArt100Credit.available! += order.priceDetails?.grossPrice || 0)
      : (welfareCategoryArt100Credit.available! -= order.priceDetails?.grossPrice || 0)
  }

  if (order.product.serviceCategory === 'welfareArt51') {
    if (welfareCategoryArt51Credit) {
      welfareCategoryArt51CreditAvailable = isCancel
        ? (welfareCategoryArt51Credit.available! += order.priceDetails?.grossPrice || 0)
        : (welfareCategoryArt51Credit.available! -= order.priceDetails?.grossPrice || 0)
    }
  }

  return {
    welfareCategoryArt100CreditAvailable,
    welfareCategoryArt51CreditAvailable,
  }
}

export const updateCredit = async (order: OrderDetailsExtended, isCancel?: boolean) => {
  console.log('MSW: updateCredit for order', order)
  const credit = await creditCollection.findFirst((q) => q.where({ membershipId: order?.userInfo?.membershipId }))
  if (credit) {
    const updatedCredits = getUpdatedCredits(credit, order, isCancel)
    if (updatedCredits.welfareCategoryArt100CreditAvailable < 0 || updatedCredits.welfareCategoryArt51CreditAvailable < 0) {
      throw new Error('Insufficient credit to start the order')
    }

    await creditCollection.update(credit, {
      data(credit) {
        const welfareCategoryArt100 = credit.creditByServiceCategory['welfareArt100']
        if (welfareCategoryArt100) {
          welfareCategoryArt100.available! = updatedCredits.welfareCategoryArt100CreditAvailable
        }

        if (order.product.serviceCategory === 'welfareArt51') {
          const welfareCategoryArt51 = credit.creditByServiceCategory['welfareArt51']
          if (welfareCategoryArt51) {
            welfareCategoryArt51.available! = updatedCredits.welfareCategoryArt51CreditAvailable
          }
        }
      },
    })
  }
}

export const updateStaticCredit = (
  credit: CreditGetResult,
  welfareArt100Used: number,
  welfareArt51Used: number,
): CreditGetResult => {
  return {
    ...credit,
    creditByServiceCategory: {
      ...credit.creditByServiceCategory,
      welfareArt100: {
        ...credit.creditByServiceCategory.welfareArt100,
        available: (credit?.creditByServiceCategory?.welfareArt100?.available || 0) - welfareArt100Used,
      },
      welfareArt51: {
        ...credit.creditByServiceCategory.welfareArt51,
        available: (credit?.creditByServiceCategory?.welfareArt51?.available || 0) - welfareArt51Used,
      },
    },
  }
}
